(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["iwearanime-launch-signup"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('dialog-component').then(() => {
    document.querySelectorAll('dialog-component[data-launch-success]').forEach((component) => {
      component.addEventListener('dialog:close', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        if (url.hash === `#${component.dataset.signupId}`) url.hash = '';
        history.replaceState(history.state, '', url);
        component.closest('.iwa-launch-signup').querySelector('.iwa-launch-signup__button').focus({ preventScroll: true });
      }, { once: true });
      component.showDialog();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
